<template>
  <span>{{ data.name }}</span>
</template>

<script>
import * as deptdoc from "@/api/base/deptdoc";

export default {
  name: "EspDeptdocView",
  data() {
    return {
      data: {}
    }
  },
  props: {
    pk: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * 查询数据
     */
    doLoadData: function () {
      if (!this.pk) {
        this.data = {};
        return;
      }
      deptdoc.get(this.pk).then(res => {
        if (res.data) {
          this.data = res.data;
        }
      }).catch(error => {
      });
    }
  },
  watch: {
    pk: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.doLoadData();
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/deptdoc/EspDeptdocView.vue